export class CampaignVideoBlock {
  private campaignVideoBlocks: NodeListOf<Element>;

  constructor() {
    this.campaignVideoBlocks = document.querySelectorAll(
      ".campaign-video-block",
    );

    this.init();
  }

  init() {
    this.campaignVideoBlocks.forEach((videoBlock) => {
      this.setupVideoPlayer(videoBlock as HTMLDivElement);
    });
  }

  setupVideoPlayer(target: HTMLDivElement) {
    const autoplay = target.dataset.videoAutoplay === "True";
    const playerElement = target.querySelector(".video") as HTMLMediaElement;

    if (!playerElement) {
      return;
    }

    // Autoplay observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && autoplay) {
            playerElement.play();
            observer.unobserve(target);
          }
        });
      },
      { threshold: 0.2 },
    );
    observer.observe(target);

    this.setupOverlay(target, playerElement);
    this.setupControls(target, playerElement);
  }

  setupOverlay(target: HTMLDivElement, playerElement: HTMLMediaElement) {
    const overlayElement = target.querySelector(".play-overlay");
    overlayElement?.addEventListener("click", () => {
      playerElement.play();
      overlayElement.remove();
    })
  }

  setupControls(target: HTMLDivElement, playerElement: HTMLMediaElement) {
    const controlsContainer = target.querySelector(".controls");
    if (!controlsContainer) {
      return;
    }

    if (!this.userCanHover()) {
      controlsContainer.classList.add("static");
    }

    const playControl = controlsContainer.querySelector(".control.play");
    const pauseControl = controlsContainer.querySelector(".control.pause");
    const soundOnControl = controlsContainer.querySelector(".control.sound-on");
    const soundOffControl = controlsContainer.querySelector(".control.sound-off");

    let moveTimer: ReturnType<typeof setTimeout>;

    // Control events
    playControl?.addEventListener("click", () => {
      playerElement.play();
    });

    pauseControl?.addEventListener("click", () => {
      playerElement.pause();
    });

    soundOnControl?.addEventListener("click", () => {
      playerElement.muted = true;
      this.showButton(soundOffControl);
      this.hideButton(soundOnControl);
    });

    soundOffControl?.addEventListener("click", () => {
      playerElement.muted = false;
      this.showButton(soundOnControl);
      this.hideButton(soundOffControl);
    });

    target.addEventListener("mousemove", () => {
      controlsContainer.classList.add("show");

      clearTimeout(moveTimer);
      moveTimer = setTimeout(() => {
        controlsContainer.classList.remove("show");
        console.log("trigger");

      }, 1250);
    });

    target.addEventListener("mouseleave", () => {
      controlsContainer.classList.remove("show");
    });

    // Player events
    playerElement.addEventListener("playing", () => {
      this.showButton(pauseControl);
      this.hideButton(playControl);
      this.removeElement(target.querySelector(".play-overlay"));
    });

    playerElement.addEventListener("pause", () => {
      this.showButton(playControl);
      this.hideButton(pauseControl);
    });

    playerElement.addEventListener("ended", () => {
      this.hideButton(pauseControl);
      this.showButton(playControl);
    });
  }

  userCanHover() {
    if (!window.matchMedia("(any-hover:none)").matches) {
      return true;
    } else {
      return false;
    }
  };

  removeElement(element: Element | null) {
    element?.remove();
  }

  showButton(button: Element | null) {
    button?.classList.remove('hidden');
  }

  hideButton(button: Element | null) {
    button?.classList.add('hidden');
  }
}
